import axios from 'axios'
//import appSettings from "../../../appsettings.json"
import Vue from "vue"
import router from '../../router'

export default {

    async getHeaders() {
        let token = await Vue.prototype.$auth.getUserToken();
        return { Authorization: `bearer ${token}` };
    },
    async createHttp() {

        let http = axios.create(
            {
                headers: await this.getHeaders(),
                baseURL: process.env.VUE_APP_API_URL,
                timeout: 120000,
                validateStatus: function (status) {
                    //console.log(status)
                    if (status == 401 || status == 403) {
                        router.push({ name: "NotAuthorized" });
                    }

                    return status >= 200 && status < 300; // default
                }
            });


        http.interceptors.request.use(request => {
            //console.log('url: ' + request.url + ' params: ' + JSON.stringify(request.params));
            return request;
        })
        return http;


    },

    getResult(res, error) {

        if (res && res.data && res.data.success != null) {
                if (!res.data.success) return { success: false, data: this.formatErrors(res)};

                if (res.data.messages?.length > 0 ) {
                    if(res.data.messages[0].indexOf('[Type:Exception]') >= 0){
                        return {success: false, data: [res.data.messages[0]]}; 
                    }
                } 
            return res.data;
        }
        else return { success: false, data: [{ key: "Error", value: error ? [error] : ['Error'] }] };//JSON.stringify(res) }] };
    },

    formatErrors(res) {

        let errors = []

        if (res.data.success != null) {
            res.data.data.forEach(d => {
                if(d.messages){
                    errors.push(d.message)
                }
                else{
                    errors.push(d.value)
                }
            });
        }
        return errors;

    },

    async get(url, params) {
        //console.log(JSON.stringify(params))
        try {
            let http = await this.createHttp();

            let res = await http.get(url, { params: params });
            return this.getResult(res);


        } catch (err) {

            if (!err || !err.response || !err.response.data) {
                return this.getResult({
                    data: { success: false, data: [{ key: "Error", value: `Request Error ${err.message}` }] }
                });
            }

            let res = err.response;
            if (res.data.success != null) {
                return this.getResult(res)
            }

            return {
                success: false, data: [{ key: "Error", value: err.message }]
            }
        }
    },

    async post(url, data, params) {

        try {
            let http = await this.createHttp();
            let res = await http.post(url, data, { params });

            return this.getResult(res);

        } catch (err) {


            if (!err || !err.response || !err.response.data) {
                return this.getResult({
                    data: { success: false, data: [{ key: "Error", value: `Request Error ${err.message}` }] }

                });
            }

            let res = err.response;
            if (res.data.success != null) {
                return this.getResult(res)
            }
            return {
                success: false, data: [{ key: "Error", value: err.message }]

            }
        }
    },
    async put(url, data, params) {
        try {
            let http = await this.createHttp();
            let res = await http.put(url, data, { params });
            return this.getResult(res);

        } catch (err) {
            if (!err || !err.response || !err.response.data) {
                return this.getResult({
                    data: { success: false, data: [{ key: "Error", value: `Request Error ${err.message}` }] }

                });
            }
            let res = err.response;
            if (res.data.success != null) {
                return this.getResult(res)
            }
            return {
                success: false, data: [{ key: "Error", value: err.message }]

            }
        }
    },

    async delete(url, id) {
        try {
            let http = await this.createHttp();
            let res = await http.delete(`${url}?id=${id}`);
            return this.getResult(res);

        } catch (err) {
            if (!err || !err.response || !err.response.data) {
                return this.getResult({
                    data: { success: false, data: [{ key: "Error", value: `Request Error ${err.message}` }] }

                });
            }

            let res = err.response;
            if (res.data.success != null) {
                return this.getResult(res)
            }
            return {
                success: false, data: [{ key: "Error", value: err.message }]

            }
        }
    },


}